import { environment } from "@envs/environment";
import { AES, enc } from "crypto-js";

export const encrypt = (data: string): string => {
  return AES.encrypt(data, environment.keyEcrypt).toString();
};

export const decrypt = <T>(valueEncrypt: string): T | null => {
  try {
    const valueDecrypt = AES.decrypt(valueEncrypt, environment.keyEcrypt).toString(enc.Utf8);
    if (!valueDecrypt) {
      return null;
    }
    return JSON.parse(valueDecrypt) as T;
  } catch {
    return null;
  }
};